export default __webpack_public_path__ + "static/media/features-dashboard.7fa8ba1d.png";